import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class SelectStepsService {
  public subject: Subject<any>;
  constructor() {
    this.subject = new Subject();
  }
}
